import React from "react";
import { useFormikContext } from "formik";
import CheckboxField from "../../../components/controls/CheckboxField";
import NumberInputField from "../../../components/controls/NumberInputField";

function FormContent() {
  const { values, handleChange, errors, setFieldValue } =
    useFormikContext<any>();

  return (
    <div>
      <NumberInputField
        setFieldValue={setFieldValue}
        value={values?.mediumCostEstimateMin}
        onChange={handleChange}
        isNegativeAllowed={false}
        errors={errors}
        name={"mediumCostEstimateMin"}
        disabled={false}
        label={"ram.clientsList.mediumLowThreshold"}
      />
      <NumberInputField
        setFieldValue={setFieldValue}
        value={values?.highCostEstimateMin}
        onChange={handleChange}
        isNegativeAllowed={false}
        errors={errors}
        name={"highCostEstimateMin"}
        disabled={false}
        label={"ram.clientsList.highMediumThreshold"}
      />
      <CheckboxField
        checked={values?.updateHierarchically}
        errors={errors}
        setFieldValue={setFieldValue}
        name={"updateHierarchically"}
        disabled={false}
        label={"ram.clientsList.updateHierarchically"}
        required={false}
      />
    </div>
  );
}

export default FormContent;
